import { BalFooter } from "@baloise/ds-react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import React from "react";

import * as style from "./footer.module.scss";
import { FooterProps } from "./footer.types";

/**
 * footer
 */
const Footer: React.FC<FooterProps> = ({ extraLinkFR, extraLinkNL }) => {
    const { t } = useTranslation();
    const today = new Date();

    return (
        <BalFooter hideLinks hideLanguageSelection>
            <div className={`container ${style.footer}`}>
                <div className={style.copyright}>
                    <span>
                        &copy; {today.getFullYear()} {t("footer.branding")}
                    </span>
                </div>
                <div className={style.linklist}>
                    <span>
                        <a
                            className="text-white"
                            target="_blank"
                            rel="noreferrer nofollow"
                            href={
                                process.env.GATSBY_CURRENT_LANGUAGE === "nl"
                                    ? "https://www.baloise.be/nl/over-ons/privacy.html"
                                    : "https://www.baloise.be/fr/a-propos-de-nous/privacy.html"
                            }
                        >
                            {t("footer.links.first")}
                        </a>
                    </span>
                    <span>
                        <a
                            className="text-white"
                            target="_blank"
                            rel="noreferrer nofollow"
                            href={
                                process.env.GATSBY_CURRENT_LANGUAGE === "nl"
                                    ? "https://contact.baloise.be/legal/nl/cookie-policy.html"
                                    : "https://contact.baloise.be/legal/fr/cookie-policy.html"
                            }
                        >
                            {t("footer.links.second")}
                        </a>
                    </span>
                    {extraLinkFR && extraLinkNL && (
                        <span>
                            <a
                                className="text-white"
                                target="_blank"
                                rel="noreferrer nofollow"
                                href={
                                    process.env.GATSBY_CURRENT_LANGUAGE === "nl"
                                        ? extraLinkNL
                                        : extraLinkFR
                                }
                            >
                                {t("footer.links.third")}
                            </a>
                        </span>
                    )}
                </div>
            </div>
        </BalFooter>
    );
};

export default Footer;
